import { ProviderGroupControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  providerGroup: any;
  xTENANTID?: string;
}

/**
 * query to handle edit provider group profile
 * @author rajkumar rathod
 */
export const useEditProviderGroupProfile = () =>
  useMutationWithLoading(async (params: Params) =>
    new ProviderGroupControllerApi(getConfigObject()).updateProviderGroup(
      params.providerGroup,
      params.xTENANTID
    )
  );
